/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { InvoiceTaskProperties } from './InvoiceTaskProperties';
import type { PerTaskProperties } from './PerTaskProperties';

export type SiteTask = {
    uuid: string;
    assignee?: number;
    update_time?: string;
    task_type: SiteTask.task_type;
    customer_id: number;
    site_name?: string;
    status: ('no_per' | 'prepare' | 'landholder_input' | 'process_changes' | 'submit' | 'finish' | 'prepare_invoice' | 'awaiting_units' | 'invoice_sent' | 'in_dispute' | 'transaction_prepared' | 'complete');
    properties?: (InvoiceTaskProperties | PerTaskProperties);
};

export namespace SiteTask {

    export enum task_type {
        PER = 'per',
        INVOICE = 'invoice',
    }


}

